import React from 'react';
import {
  Grid,
  InputAdornment,
  TextField,
  FormControlLabel,
  Checkbox,
  Chip,
  Typography,
} from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { get, isNil } from 'lodash';
import { COLORS } from 'constants/design';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import { translate } from 'containers/services/translate';
import { StyledGrid } from 'containers/ExpertExpertise/FillExpertise/style';
import Document from 'components/Document';
import CustomSelect from 'containers/ExpertExpertise/FillExpertise/CustomSelect';
import { configToItems } from 'containers/ExpertExpertise/FillExpertise/utils';
import { handleOpenDocument } from 'services/utils';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import {
  VICTIM_EXPERTISE_FIELDS,
  MISSION_EXPERISE_VICTIM_STATUS,
} from 'containers/data-structure';
import ActionButton from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ActionButton';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import { MISSION_EXPERTISE_VICTIM_TYPE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import LabelValue from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/LabelValue';
import { shouldDisplayWarningIpp } from 'containers/TransactionManagerTimeLine/utils';

export interface MedicalFormRecapProps {
  intl: IntlShape;
  recap: any;
  isLawyer?: boolean;
  handleOpenDialogValidation: Function;
  handleOpenDialogRejection: Function;
  handleOpenAppreciationDialog: Function;
  isTransaction?: boolean;
  expertises?: any;
  requestGetDocByDocumentumId: Function;
}
const MedicalFormRecap: React.FC<MedicalFormRecapProps> = props => {
  const listings = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings'], []),
  );
  const thirdPartyAppealsItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'thirdPartyAppeals'], []),
  );

  const pretiumDolorisItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'pretiumDoloris'], []),
  );

  const aestheticDamageWithoutConsequenceItems = useSelector((state: any) =>
    get(
      state.toJS(),
      ['appContainer', 'listings', 'aestheticDamageWithoutConsequence'],
      [],
    ),
  );

  const aestheticDamageWithConsequenceItems = useSelector((state: any) =>
    get(
      state.toJS(),
      ['appContainer', 'listings', 'aestheticDamageWithConsequence'],
      [],
    ),
  );

  const careerPrejudiceItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'careerPrejudice'], []),
  );

  const schoolingPrejudiceItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'schoolingPrejudice'], []),
  );

  const IsChecked = get(
    props.recap,
    VICTIM_EXPERTISE_FIELDS.IS_DEATH_RELATED_TO_CLAIM,
    false,
  );
  return (
    <>
      {props.recap.victim.injuryPostKey === INJURY_POST_DECEASED ? (
        <StyledGrid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            {!props.isTransaction && (
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={4}>
                  <LabelValue
                    title={
                      translate(messages.referenceMisionTitle, props) + ':'
                    }
                    value={get(props.recap, 'mission.reference')}
                  />
                </Grid>

                {get(props.recap, 'mission.courtFileNumber') && (
                  <Grid item xs={4}>
                    <LabelValue
                      title={
                        translate(messages.courtFileNumberTitle, props) + ':'
                      }
                      value={get(props.recap, 'mission.courtFileNumber')}
                    />
                  </Grid>
                )}

                <Grid item xs={4}>
                  <LabelValue
                    title={translate(messages.procedureTypeTitle, props) + ':'}
                    value={
                      getValueByCode(
                        get(props.recap, 'mission.procedureNatureId'),
                        get(listings, 'procedureNature'),
                      ) as any
                    }
                  />
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid item xs={6}>
            <TextField
              title={
                get(props.recap, 'type', '') ===
                MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                  ? translate(messages.commentAppreciationTitle, props)
                  : translate(messages.comment, props)
              }
              label={
                get(props.recap, 'type', '') ===
                MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                  ? translate(messages.commentAppreciationTitle, props)
                  : translate(messages.comment, props)
              }
              defaultValue={get(props.recap, 'comment')}
              name="comment"
              fullWidth
              InputProps={{
                disabled: true,
              }}
            />
          </Grid>
          {(!props.recap.status ||
            props.recap.status === MISSION_EXPERISE_VICTIM_STATUS.PENDING) && (
            <Grid item xs={4}>
              {!props.isLawyer && (
                <ActionButton
                  handleOpenDialogValidation={props.handleOpenDialogValidation}
                  handleOpenDialogRejection={props.handleOpenDialogRejection}
                  shouldDisplayAppreciation={
                    get(props.recap, 'mission.assignedExperts', []).length === 1
                  }
                  handleOpenAppreciationDialog={
                    props.handleOpenAppreciationDialog
                  }
                  isTransaction={props.isTransaction}
                  shouldDisplayOnlyAppreciation={shouldDisplayWarningIpp(
                    props.expertises,
                  )}
                />
              )}
            </Grid>
          )}
          <Grid item xs={6}>
            <div className="spaceBloc">
              <FormControlLabel
                name={VICTIM_EXPERTISE_FIELDS.IS_DEATH_RELATED_TO_CLAIM}
                control={
                  <Checkbox
                    name={VICTIM_EXPERTISE_FIELDS.IS_DEATH_RELATED_TO_CLAIM}
                    checked={IsChecked}
                    color="primary"
                    disabled={true}
                  />
                }
                label={translate(messages.isDeathRelatedToClaim, props)}
              />
            </div>
          </Grid>
          {featureService.hasFeature(FEATURES.TRANSACTION) && (
            <>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.certificatDescription, props)}
                  label={translate(messages.certificatDescription, props)}
                  value={props.recap.certificatDescription}
                  fullWidth
                  InputProps={{
                    disabled: true,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  title={translate(messages.clinicalExamination, props)}
                  label={translate(messages.clinicalExamination, props)}
                  value={props.recap.clinicalExamination}
                  fullWidth
                  InputProps={{
                    disabled: true,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.injuryDescription, props)}
                  label={translate(messages.injuryDescription, props)}
                  value={props.recap.injuryDescription}
                  fullWidth
                  InputProps={{
                    disabled: true,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <section>
              {props.recap.document && (
                <div className="support-document-info">
                  <Document
                    name={get(props.recap.document, 'name', '')}
                    type={get(props.recap.document, 'type', '')}
                    icon={
                      <VisibilityIcon
                        className="consult"
                        onClick={handleOpenDocument(
                          props.recap.document,
                          props.requestGetDocByDocumentumId,
                        )}
                      />
                    }
                  />
                </div>
              )}
            </section>
          </Grid>
          <Grid item>
            <Typography
              style={{
                color: COLORS.LIGHT_GREY,
                fontWeight: 400,
                fontSize: '13px',
              }}
            >
              {translate(messages.statusTitle, props)}
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Chip
              style={{
                backgroundColor: renderColor(props.recap?.status),
                color: COLORS.WHITE,
                fontWeight: 700,
              }}
              label={renderChipLabel(props.recap?.status)}
            />
          </Grid>
          {get(props.recap, 'decisionComment') && (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.comment, props) + ':'}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{
                    color: COLORS.TEXT_BLACK,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {get(props.recap, 'decisionComment')}
                </Typography>
              </Grid>
            </>
          )}
          {get(props.recap, 'rejectionReason') &&
            get(props.recap, 'status') ===
              MISSION_EXPERISE_VICTIM_STATUS.REJECTED && (
              <>
                <Grid item>
                  <Typography
                    style={{
                      color: COLORS.LIGHT_GREY,
                      fontWeight: 400,
                      fontSize: '13px',
                    }}
                  >
                    {translate(messages.reason, props) + ':'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    style={{
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 400,
                      fontSize: '13px',
                    }}
                  >
                    {get(props.recap, 'rejectionReason')}
                  </Typography>
                </Grid>
              </>
            )}
          {get(props.recap, 'createdBy') && (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.createdByTitle, props)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: COLORS.TEXT_BLACK,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {getValueByCodeSagis(
                    get(props.recap, 'createdBy') as string,
                    get(listings, 'intervenants'),
                  )}
                </Typography>
              </Grid>
            </>
          )}
        </StyledGrid>
      ) : (
        <StyledGrid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            {!props.isTransaction && (
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={4}>
                  <LabelValue
                    title={
                      translate(messages.referenceMisionTitle, props) + ':'
                    }
                    value={get(props.recap, 'mission.reference')}
                  />
                </Grid>

                {get(props.recap, 'mission.courtFileNumber') && (
                  <Grid item xs={4}>
                    <LabelValue
                      title={
                        translate(messages.courtFileNumberTitle, props) + ':'
                      }
                      value={get(props.recap, 'mission.courtFileNumber')}
                    />
                  </Grid>
                )}

                <Grid item xs={4}>
                  <LabelValue
                    title={translate(messages.procedureTypeTitle, props) + ':'}
                    value={
                      getValueByCode(
                        get(props.recap, 'mission.procedureNatureId'),
                        get(listings, 'procedureNature'),
                      ) as any
                    }
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              name="medicalPharmaceuticalFees"
              label={translate(messages.medicalPharmaceuticalFees, props)}
              defaultValue={props.recap.medicalPharmaceuticalFees}
              type="number"
              fullWidth
              InputProps={{
                disabled: true,
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              name="itt"
              label={translate(messages.itt, props)}
              defaultValue={props.recap.itt}
              type="number"
              fullWidth
              InputProps={{
                disabled: true,
              }}
            />
          </Grid>
          {(!props.recap.status ||
            props.recap.status === MISSION_EXPERISE_VICTIM_STATUS.PENDING) && (
            <Grid item xs={4}>
              {!props.isLawyer && (
                <ActionButton
                  handleOpenDialogValidation={props.handleOpenDialogValidation}
                  handleOpenDialogRejection={props.handleOpenDialogRejection}
                  shouldDisplayAppreciation={
                    get(props.recap, 'mission.assignedExperts', []).length === 1
                  }
                  handleOpenAppreciationDialog={
                    props.handleOpenAppreciationDialog
                  }
                  isImportedExpertise={
                    !isNil(
                      get(
                        props.recap,
                        'mission.transactionMission.importedMissionId',
                        null,
                      ),
                    )
                  }
                  isTransaction={props.isTransaction}
                  shouldDisplayOnlyAppreciation={shouldDisplayWarningIpp(
                    props.expertises,
                  )}
                />
              )}
            </Grid>
          )}
          <Grid item xs={4}>
            <TextField
              name="ipp"
              label={translate(messages.ipp, props)}
              defaultValue={props.recap.ipp}
              type="number"
              fullWidth
              InputProps={{
                disabled: true,
                endAdornment: (
                  <InputAdornment position="end">
                    {translate(messages.expertReportpourcentage, props)}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <CustomSelect
              title={translate(messages.thirdPartyAppeals, props)}
              items={configToItems(thirdPartyAppealsItems)}
              value={props.recap.thirdPartyAppeal}
              disabled={true}
            />
          </Grid>
          <Grid item xs={4}>
            <CustomSelect
              title={translate(messages.pretiumDoloris, props)}
              items={configToItems(pretiumDolorisItems)}
              value={props.recap.pretiumDoloris}
              disabled={true}
            />
          </Grid>
          <Grid item xs={4}>
            <CustomSelect
              title={translate(messages.aestheticHarmWithoutConsequence, props)}
              items={configToItems(aestheticDamageWithoutConsequenceItems)}
              value={props.recap.aestheticDamageWithoutConsequence}
              disabled={true}
            />
          </Grid>
          <Grid item xs={4}>
            <CustomSelect
              title={translate(messages.aestheticDamageWithConsequence, props)}
              items={configToItems(aestheticDamageWithConsequenceItems)}
              value={props.recap.aestheticDamageWithConsequence}
              disabled={true}
            />
          </Grid>
          <Grid item xs={4}>
            <CustomSelect
              title={translate(messages.careerPrejudice, props)}
              items={configToItems(careerPrejudiceItems)}
              value={props.recap.careerPrejudice}
              disabled={true}
            />
          </Grid>
          <Grid item xs={4}>
            <CustomSelect
              title={translate(messages.schoolingPrejudice, props)}
              items={configToItems(schoolingPrejudiceItems)}
              value={props.recap.schoolingPrejudice}
              disabled={true}
            />
          </Grid>

          <Grid item xs={4}>
            <TextField
              title={
                get(props.recap, 'type', '') ===
                MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                  ? translate(messages.commentAppreciationTitle, props)
                  : translate(messages.comment, props)
              }
              label={
                get(props.recap, 'type', '') ===
                MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                  ? translate(messages.commentAppreciationTitle, props)
                  : translate(messages.comment, props)
              }
              defaultValue={props.recap.comment}
              fullWidth
              InputProps={{
                disabled: true,
              }}
            />
          </Grid>
          {featureService.hasFeature(FEATURES.TRANSACTION) && (
            <>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.certificatDescription, props)}
                  label={translate(messages.certificatDescription, props)}
                  value={props.recap.certificatDescription}
                  fullWidth
                  InputProps={{
                    disabled: true,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.clinicalExamination, props)}
                  label={translate(messages.clinicalExamination, props)}
                  value={props.recap.clinicalExamination}
                  fullWidth
                  InputProps={{
                    disabled: true,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  title={translate(messages.injuryDescription, props)}
                  label={translate(messages.injuryDescription, props)}
                  value={props.recap.injuryDescription}
                  fullWidth
                  InputProps={{
                    disabled: true,
                  }}
                  inputProps={{
                    style: {
                      overflowY: 'auto',
                      height: 'auto',
                    },
                  }}
                  rows={6}
                  multiline
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <section>
              {props.recap.document && (
                <div className="support-document-info">
                  <Document
                    name={get(props.recap.document, 'name', '')}
                    type={get(props.recap.document, 'type', '')}
                    icon={
                      <VisibilityIcon
                        className="consult"
                        onClick={handleOpenDocument(
                          props.recap.document,
                          props.requestGetDocByDocumentumId,
                        )}
                      />
                    }
                  />
                </div>
              )}
            </section>
          </Grid>
          <Grid item>
            <Typography
              style={{
                color: COLORS.LIGHT_GREY,
                fontWeight: 400,
                fontSize: '13px',
              }}
            >
              {translate(messages.statusTitle, props)}
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Chip
              style={{
                backgroundColor: renderColor(props.recap?.status),
                color: COLORS.WHITE,
                fontWeight: 700,
              }}
              label={renderChipLabel(props.recap?.status)}
            />
          </Grid>
          {get(props.recap, 'decisionComment') && (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.comment, props) + ':'}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: COLORS.TEXT_BLACK,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {get(props.recap, 'decisionComment')}
                </Typography>
              </Grid>
            </>
          )}
          {get(props.recap, 'status') ===
            MISSION_EXPERISE_VICTIM_STATUS.REJECTED &&
            get(props.recap, 'rejectionReason') && (
              <>
                <Grid item>
                  <Typography
                    style={{
                      color: COLORS.LIGHT_GREY,
                      fontWeight: 400,
                      fontSize: '13px',
                    }}
                  >
                    {translate(messages.reason, props) + ':'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    style={{
                      color: COLORS.TEXT_BLACK,
                      fontWeight: 400,
                      fontSize: '13px',
                    }}
                  >
                    {get(props.recap, 'rejectionReason')}
                  </Typography>
                </Grid>
              </>
            )}
          {get(props.recap, 'createdBy') && (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.createdByTitle, props)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: COLORS.TEXT_BLACK,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {getValueByCodeSagis(
                    get(props.recap, 'createdBy') as string,
                    get(listings, 'intervenants'),
                  )}
                </Typography>
              </Grid>
            </>
          )}
        </StyledGrid>
      )}
    </>
  );
};

export default injectIntl(MedicalFormRecap);
